(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/betslip-registry/assets/javascripts/betslip-registry.js') >= 0) return;  svs.modules.push('/components/tipsen/betslip-registry/assets/javascripts/betslip-registry.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useState = _React.useState,
  useMemo = _React.useMemo;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const analytics = svs.components.analytics;
const Drawer = svs.components.lbUi.Drawer;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_SM = _svs$components$lbUti.BREAKPOINT_SM,
  BREAKPOINT_MD = _svs$components$lbUti.BREAKPOINT_MD;
const betslipForceTypes = svs.components.sport.tipsenShared.betslipForceTypes;
const useComponentFromRegistry = svs.components.tipsen.componentRegistry.useComponentFromRegistry;
const useCouponId = svs.components.tipsen.couponId.useCouponId;
const CenterToScreen = svs.components.tipsen.centerToScreen.CenterToScreen;
const Betslip = svs.components.tipsen.betslipComponents.Betslip;
const selectDisplayName = svs.components.tipsen.engine.selectors.engineSelectors.selectDisplayName;
const selectCouponSignCount = svs.components.tipsen.engine.selectors.couponSelectors.selectCouponSignCount;
const BetslipDrawerContent = svs.components.tipsen.betslipDrawerContent.BetslipDrawerContent;
const _svs$components$tipse = svs.components.tipsen.betslipRegistry,
  BetslipButton = _svs$components$tipse.BetslipButton,
  MenuButton = _svs$components$tipse.MenuButton,
  useGetBetslipForceType = _svs$components$tipse.useGetBetslipForceType,
  useIsScrolling = _svs$components$tipse.useIsScrolling;
const selectCouponStatus = svs.components.tipsen.engine.selectors.couponSelectors.selectCouponStatus;
const COUPON_VALID = svs.components.tipsen.engine.constants.couponStatus.COUPON_VALID;
const BETSLIP_BASE_HEIGHT_MOBILE = 87;
const BETSLIP_BASE_HEIGHT_MOBILE_ONGOING = 65;
const DRAWER_TAB_HEIGHT = 10;
const isIOSWithSafari = svs.core.detect.os.iOS() && svs.core.detect.browser.safari();
const BetslipRegistry = () => {
  const betslipContainerRef = useRef(null);
  const BetslipSelector = useComponentFromRegistry('betslip-selector');
  const betslipForceType = useGetBetslipForceType();
  const couponId = useCouponId();
  const displayName = useSelector(selectDisplayName);
  const couponSignCount = useSelector(state => selectCouponSignCount(state, couponId));
  const isExtraSmallDevice = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  const isSmallDevice = useMediaQuery(breakpoints.down(BREAKPOINT_MD));

  const isScrolling = useIsScrolling(600);
  const preventDrawerTransitionOnIOSWithSafari = isScrolling && isIOSWithSafari;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showDrawer = _useState2[0],
    setShowDrawer = _useState2[1];
  window.addEventListener('payButtonScroll', () => setShowDrawer(false));
  const couponStatus = useSelector(state => selectCouponStatus(state, couponId));
  const isCouponValid = useMemo(() => couponStatus === COUPON_VALID, [couponStatus]);
  let betslipBaseHeight = BETSLIP_BASE_HEIGHT_MOBILE_ONGOING;
  if (isCouponValid) {
    betslipBaseHeight = BETSLIP_BASE_HEIGHT_MOBILE;
  }
  const betslipStyle = {
    '--betslip-base-height-mobile': "".concat(betslipBaseHeight, "px")
  };
  const drawerStyle = {
    '--betslip-base-height-mobile': "".concat(betslipBaseHeight, "px")
  };
  if (!showDrawer) {
    drawerStyle['--drawer-tab-height'] = "".concat(DRAWER_TAB_HEIGHT, "px");
  }
  const handleOpen = () => {
    setShowDrawer(true);
  };
  const handleOpenOrClose = event => {
    event.stopPropagation();
    setShowDrawer(!showDrawer);
  };
  useEffect(() => {
    if (betslipForceType === betslipForceTypes.BETSLIP) {
      gsap.to(betslipContainerRef.current, {
        y: 0,
        ease: 'power1.in',
        duration: 0.3
      });
    } else {
      gsap.to(betslipContainerRef.current, {
        y: 160,
        ease: 'power1.out',
        duration: 0.3
      });
    }
  }, [betslipForceType]);
  useEffect(() => {
    if (showDrawer) {
      analytics.trackEvent({
        category: 'Nya tipsen',
        action: 'Coupon Overview',
        opt_label: displayName
      });
    }
  }, [displayName, showDrawer]);
  const showBetslipMenuTab = couponSignCount > 0 && isExtraSmallDevice;
  return React.createElement("section", {
    "aria-label": "Betslip",
    className: "pg_betslip_container",
    ref: betslipContainerRef
  }, isSmallDevice && betslipForceType === betslipForceTypes.BETSLIP && React.createElement(Drawer, {
    className: "pg_betslip_drawer",
    direction: "bottom",
    expandableAreaHeight: BETSLIP_BASE_HEIGHT_MOBILE,
    isOpen: showDrawer,
    onClickOverlay: () => setShowDrawer(false),
    style: _objectSpread(_objectSpread({}, drawerStyle), preventDrawerTransitionOnIOSWithSafari ? {
      transition: 'none'
    } : {})
  }, React.createElement(BetslipDrawerContent, {
    handleOpen: handleOpen,
    handleOpenOrClose: handleOpenOrClose,
    style: drawerStyle
  })), React.createElement("div", {
    className: "pg_tipsen_betslip",
    style: betslipStyle
  }, React.createElement(CenterToScreen, {
    className: "pg_tipsen_betslip__centered_container"
  }, isExtraSmallDevice && !showDrawer && React.createElement(MenuButton, null), React.createElement(Betslip, null, React.createElement(BetslipSelector, null)))), showBetslipMenuTab && React.createElement(BetslipButton, {
    isVisible: betslipForceType === betslipForceTypes.MENU
  }));
};
setGlobal('svs.components.tipsen.betslipRegistry.BetslipRegistry', BetslipRegistry);

 })(window);